<template>
    <Chart
        card
        class="mt-3"
        :height="400"
        :series="[]"
        :options="chartOptions"
        :header="$t('priceSchedule')"
        :error="requestChart.getError()"
        :loading="requestChart.getLoading()"
        :range="groupBy"
    >
        <template #nav>
            <Multiselect
                :value="pluginCampaigns"
                :placeholder="$t('campaigns')"
                :disabled="requestChart.getLoading()"
                :options="pluginCampaignsOptions"
                :multiple="false"
                :allow-empty="false"
                class="width-min-250"
                @inputTrackBy="pluginCampaigns = $event"
                @change="fetchChart()"
            />
        </template>
    </Chart>
</template>



<script>
    import Chart from '@/components/common/Chart.vue';
    import { chartDataGroupBy } from '@/utils/chart';
    import Multiselect from '@/components/common/Multiselect.vue';

    export default {
        name: 'PriceChart',
        components: {
            Chart,
            Multiselect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.parentComponent.requestPriceChart,
                pluginCampaigns: 'in',
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                return {
                    urlParams: {
                        id: this.item.id,
                    },
                    requestParams: {
                        ...(this.timeRange || {}),
                        groupBy: this.groupBy,
                        pluginCampaigns: this.pluginCampaigns,
                    },
                };
            },
            groupBy() {
                return chartDataGroupBy(this.timeRange);
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartOptions() {
                if (!this.chartData.length) return {};
                const keys = Object.keys(this.chartData[0]).filter(item => item !== 'date');
                const labels = this.chartData.map(item => new Date(item.date).getTime());
                const data = keys.map(key => ({ name: key, data: [] }));
                const chartData = this.chartData.reduce((acc, item) => {
                    acc.forEach(el => {
                        el.data.push(item[el.name]);
                    });
                    return acc;
                }, data);
                const hasData = !!chartData.find(item => item.data.find(el => el));
                return {
                    series: hasData ? chartData : [],
                    labels,
                    chart: {
                        type: 'line',
                    },
                    stroke: {
                        curve: 'stepline',
                    },
                };
            },
            pluginCampaignsOptions() {
                return [
                    { value: 'in', text: this.$t('pluginCampaignsFormOptions.in') },
                    { value: 'notIn', text: this.$t('pluginCampaignsFormOptions.notIn') },
                    { value: null, text: this.$t('pluginCampaignsFormOptions.all') },
                ];
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'loadData',
            },
            timeRange: {
                immediate: false,
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.fetchChart();
            },
            fetchChart(params = {}) {
                this.requestChart.get(this.apiParams);
            },
        },
    };
</script>



<style lang="scss" scoped></style>
